import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import MainLinks from "../components/navlinks/MainLinks";
import Body from "../components/body/BodyPage";
import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBChip,
    MDBInput,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
    MDBTextArea,
    MDBSpinner,
    MDBBtn,
    MDBRow,
    MDBCol,
    MDBScrollspy,
    MDBScrollspyLink,
    MDBIcon,
    MDBAlert
} from "mdb-react-ui-kit";
import { useLocation } from "react-router-dom";
import { getAppDetails, updateStreamApiApp, checkAppNameAvailabilityInfo } from "../apiclients/streamsapi_bridge";
import { useForm } from "react-hook-form";
import SaveChanges from "../components/topviews/saveCancel";
import { Tooltip } from "react-tooltip";
import { Link } from "react-router-dom";
import RegenerateClientSecretPopup from "./popups/streamsapi/RegenerateClientSecretPopup";
import { StreamsPermissions } from "./popups/streamsapi/StreamsPermissions";
import StreamsAPIWebHookURLAlert from "./popups/streamsapi/StreamsAPIWebHookURLAlert";
import UIConstant from "../apiclients/UIConstant";

function StreamsApiSettings() {
    const location = useLocation();
    const [data] = useState(location.state?.data);
    const [appInfo, setAppInfo] = useState({});
    const { t } = useTranslation();
    const [basicActive, setBasicActive] = useState("tab1");
    const [loading, setLoading] = useState(false);
    const [isFirstImage, setIsFirstImage] = useState(false);
    const [isRegeneratePopup, setRegeneratePopup] = useState(false);
    const [tooltipText, setTooltipText] = useState("Copy");
    const [showTooltip, setShowTooltip] = useState(false);
    const [selectedPermissionsbk, setSelectedPermissionsbk] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [apiUrls, setapiUrls] = useState({});
    const [istoggleAlertPopup, SetIstoggleAlertPopup] = useState(false);
    const [actionType, setActionType] = useState(false);
    const [formData, setFormData] = useState(null);
    const [alertHeader, setAlertHeader] = useState("");
    const [changedWebhooks, setChangedWebhooks] = useState([]);



    const [formDefaultValues, setFormDefaultValues] = useState({
        settingsInfo: appInfo,
        app_permission: selectedPermissions,
        api_urls: apiUrls
    });
    const { register, reset, formState: { errors, isDirty, dirtyFields }, setValue, handleSubmit, getValues, watch, resetField, trigger,clearErrors,setError } = useForm({ defaultValues: formDefaultValues });


    const handleBasicClick = (value) => {
        if (value === basicActive) return;
        setBasicActive(value);
    };
    

    const fetchAppInfo = async () => {
        setLoading(true);
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        try {
            const saverepData = await getAppDetails(siteid, location.state.data.id);
            if (!saverepData.ok) {
                console.error("Network response was not ok");
                throw new Error("Failed to fetch app details.");
            }
            const response = await saverepData.json();
            console.log("response ::: " + JSON.stringify(response));

            // ---- When API loads ----
            setAppInfo(response.AppsInfo);
            setapiUrls(response?.webhook_urls)

            // fetch response
            setSelectedPermissions(response?.app_permission);
            setSelectedPermissionsbk(response?.app_permission);

        } catch (error) {
            console.error("Error fetching app info:", error);
        }
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    };

    const onCloseChanges = () => {
        reset({ settingsInfo: appInfo, app_permission: selectedPermissionsbk, api_urls: apiUrls });
        console.log(getValues(`api_urls`))
        setSelectedPermissions(selectedPermissionsbk)
    };

    const cancelApiUrls = () => {
        const currentValues = getValues();
        const resetObj = {
            settingsInfo: currentValues.settingsInfo || formDefaultValues.settingsInfo || appInfo,
            app_permission: currentValues.app_permission || formDefaultValues.app_permission || selectedPermissions,
            api_urls: apiUrls
        };
        reset(resetObj, {
            keepDirty: true
        });
        console.log("dirtyFields :::: " + JSON.stringify(dirtyFields));
        console.log("isDirty ::::::::: " + isDirty)
        SetIstoggleAlertPopup(false);
        setActionType(false);
    };
    const WEBHOOK_LABELS = UIConstant.WEBHOOKURLkEYS;

    const getWebhookDisplayName = (key) => {
        return WEBHOOK_LABELS[key] || key;
    };

    const getChangedWebhooks = () => {
        if (!dirtyFields?.api_urls) return [];
        // Only include keys that are actually edited
        return Object.keys(dirtyFields.api_urls).filter(key => dirtyFields.api_urls[key]);
    };

    const onsaveChanges = async (formData) => {
        try {
            console.log("[handleSubmit] Making server request to submit ", formData);
            console.log("[handleSubmit] Making server request to submit ", dirtyFields);
            if (isDirty) {
                setFormData(formData)
            const changedWebhooks = getChangedWebhooks(); // e.g., ["CTC", "Inbound_SMS"]
            const displayNames = changedWebhooks.map(getWebhookDisplayName);
           if (displayNames.length > 0 && !actionType) {
                 setChangedWebhooks(displayNames);
                // Build dynamic header
                const headerText = displayNames.length > 1 ? displayNames.join(", ") : displayNames[0];
                setAlertHeader(headerText);   // Pass to modal
                SetIstoggleAlertPopup(true);  // Show modal
                return;
            }

                setLoading(true);
                const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;

                const updateData = frameParams(formData)
                console.log("[handleSubmit] framed json object ", updateData);

                const response = await updateStreamApiApp(siteid, formData.settingsInfo.stream_app_id, updateData);

                if (response.ok) {
                    const updatedData = await response.json();
                    localStorage.setItem("s_message", " Streams API App Updated Successfully!")
                } else {
                    throw new Error("Failed to update Streams API App details");
                }
                setLoading(false);
                window.location.reload()
            }


        } catch (e) {
            console.error("[onsaveChanges] Error while making server request ", e);
            setLoading(false);
        }
    }

    const saveButtonChanges=async()=>{
        try {
            setLoading(true);
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;

            const updateData = frameParams(formData)
            console.log("[handleSubmit] framed json object ", updateData);

            const response = await updateStreamApiApp(siteid, formData.settingsInfo.stream_app_id, updateData);

            if (response.ok) {
                const updatedData = await response.json();
                localStorage.setItem("s_message", " Streams API App Updated Successfully!")
            } else {
                throw new Error("Failed to update Streams API App details");
            }
            setLoading(false);
            window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }

    const frameParams = (formData) => {
        try {
            console.log("Dirty Fields :::" + JSON.stringify(dirtyFields));
            var formFields = {};

            let settingsinfo_dirtyFields = dirtyFields?.settingsInfo ?? {};
            let api_urls_dirtyFields = dirtyFields?.api_urls ?? {};
            console.log("formData :::: " + formData);

            if (Object.keys(settingsinfo_dirtyFields).length > 0) {
                formFields.settingsInfo = {}
                Object.keys(settingsinfo_dirtyFields).map((key) => {
                    if (settingsinfo_dirtyFields[key]) {
                        formFields.settingsInfo[key] = formData?.settingsInfo[key];
                    }
                });
            }
            if (dirtyFields?.app_permission) {
                formFields.app_permissions = formData?.app_permission
            }
            if (Object.keys(api_urls_dirtyFields).length > 0) {
                formFields.api_urls = {};
                Object.keys(api_urls_dirtyFields).forEach((key) => {
                    if (api_urls_dirtyFields[key]) {
                        formFields.api_urls[key] = formData?.api_urls[key];
                    }
                });
                formFields.sitename = JSON.parse(sessionStorage.getItem("admin_session")).sitename;
            }

            return formFields
        } catch (error) {
            console.log("Error in [StreamsApiSettings.js.js][frameParams] :" + error);
        }
    }

    const removePermission = (permissionId) => {
        const permInfo = selectedPermissions.filter(p => p.app_permission_id !== permissionId)
        setSelectedPermissions(permInfo);
        setValue("app_permission", permInfo, { shouldDirty: true })
    };

    const togglePermission = (permissionId) => {
        const exists = selectedPermissions?.some(p => p.app_permission_id === permissionId);
        if (!exists) {
            setSelectedPermissions((prev) => [...prev, { app_permission_id: permissionId }]);
            let permissionInfo = [...selectedPermissions, { app_permission_id: permissionId }]
            setValue("app_permission", permissionInfo, { shouldDirty: true })
        } else {
            removePermission(permissionId)
        }
        console.log(dirtyFields);
        // trigger("permissionsValidation");
       

    };
    const handleWebhookChange = (key, value) => {
        console.log("smnsd", key, value)
        setValue(`api_urls.${key}`, value, { shouldDirty: true })
    };

    useEffect(() => {
        fetchAppInfo();
    }, []);

    useEffect(() => {
        reset({ settingsInfo: appInfo, });
    }, [appInfo, reset]);

    const containerRef = useRef(null);
    const section1 = useRef(null);
    const section2 = useRef(null);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll(".nav-link");
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest(".sticky-top");
            if (stickyParent && lastLink.classList.contains("active")) {
                lastLink.classList.remove("active");
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest(".sticky-top");
                    if (parent) {
                        firstLink.classList.add("active");
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            setTimeout(() => {
                container.scrollTo({
                    top: 5,
                    behavior: "smooth",
                });

                setTimeout(() => {
                    container.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                }, 100);
            }, 500);
        }
    }, [loading]);

    const copyToClipboard = async (text) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                console.log("Copied:", text);
            } catch (err) {
                console.error("Failed to copy:", err);
            }
        } else {
            // fallback for insecure contexts
            const textarea = document.createElement("textarea");
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            console.log("Copied with fallback:", text);
        }
        setTooltipText("Copied!");
        setShowTooltip(true)
    };



    const toggleImage = () => {
        setIsFirstImage(!isFirstImage);
    };



    const checkAppNameAvailability = async (name) => {
        try {
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const params = {
                appname: name
            }
            const res = await checkAppNameAvailabilityInfo(siteid, params);
            const response = await res.json();

            return response.appIsAvailable ?? false;

        } catch (error) {
            console.error("Error checking app name availability:", error);
            return false; // in case of error, treat as not available
        }
    }

    return (
        <React.Fragment>
            <MainLinks active={6} />
            <Body
                tablinks={6}
                sublink={4}
                content={
                    <>
                        <section className="mb-3">
                            <div className="card card-height">
                                <div className="card-header py-3 px-0">
                                    <h5 className="mb-0">
                                        <MDBBreadcrumb>
                                            <MDBBreadcrumbItem>
                                                <strong>{t("AdminTools")}</strong>
                                            </MDBBreadcrumbItem>
                                            <MDBBreadcrumbItem active>
                                                <Link to="/apilanding" state={{ defaultTab: "tab3" }}>
                                                    <strong>{t("Streams API Apps")}</strong>
                                                </Link>
                                            </MDBBreadcrumbItem>
                                            <MDBBreadcrumbItem>
                                                <strong>{appInfo?.appname}</strong>
                                            </MDBBreadcrumbItem>
                                        </MDBBreadcrumb>
                                    </h5>
                                </div>

                                {loading ? (
                                    <div>
                                        <div className="loadingclass-popup"></div>
                                        <div className="popup-bg-loader loader_align">
                                            <MDBBtn disabled>
                                                <MDBSpinner
                                                    size="sm"
                                                    role="status"
                                                    tag="span"
                                                    className="me-2"
                                                />
                                                Loading...
                                            </MDBBtn>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="pb-2">
                                            <h5 className="mt-2">
                                                {appInfo?.appname}
                                            </h5>
                                            <p className="mt-2 text-secondary">
                                                {appInfo?.status === 2 ? "Production" : "Development"}
                                            </p>
                                        </div>
                                        <div className="card-body px-0 w-100">
                                            <form onSubmit={() => handleSubmit(onsaveChanges)()}>
                                                <MDBTabs className='mb-3'>
                                                    <MDBTabsItem>
                                                        <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                            Settings
                                                        </MDBTabsLink>
                                                    </MDBTabsItem>
                                                </MDBTabs>
                                                <MDBTabsContent>
                                                    <MDBTabsPane open={basicActive === 'tab1'}>
                                                        <MDBRow>
                                                            <MDBCol
                                                                size="2"
                                                                md="2"
                                                                lg="2"
                                                                sm="12"
                                                                className="col-sm-100 pr-0 leftTabs"
                                                            >
                                                                <MDBScrollspy container={containerRef}>
                                                                    <MDBScrollspyLink targetRef={section1}>
                                                                        {t("general")}
                                                                    </MDBScrollspyLink>
                                                                    <MDBScrollspyLink targetRef={section2}>
                                                                        Client Credentials
                                                                    </MDBScrollspyLink>
                                                                </MDBScrollspy>
                                                            </MDBCol>

                                                            <MDBCol
                                                                size="12"
                                                                md="10"
                                                                sm="12"
                                                                pr-0
                                                                className="col-sm-100 pr-0 leftTabContent"
                                                            >
                                                                <div ref={containerRef} className="scrollspy-example2">
                                                                    <section ref={section1} id="section-1">
                                                                        <div className="general-settings" id="general">
                                                                            General Settings
                                                                        </div>
                                                                        <div className="add-numbermain">
                                                                            <div className="tel-numbers">Application Name <span style={{ color: "red" }}>*</span></div>
                                                                            <div className="w-30">
                                                                                <MDBInput
                                                                                    type="text"
                                                                                    {...register("settingsInfo.appname", {
                                                                                        required: "Application name should not be empty",
                                                                                        minLength: { value: 3, message: "Application Name must be at least 3 characters" },
                                                                                        validate: async (value) => {
                                                                                            if (value.length < 3) return true;
                                                                                            const available = dirtyFields?.settingsInfo?.appname ? await checkAppNameAvailability(value) : true;
                                                                                            if (!available) {
                                                                                                return "This application name is already taken";
                                                                                            }
                                                                                            return true;
                                                                                        }
                                                                                    })}
                                                                                />
                                                                                {errors.settingsInfo?.appname && (
                                                                                    <div className="text-danger mt-1">
                                                                                        {errors.settingsInfo.appname.message}
                                                                                    </div>
                                                                                )}
                                                                                {!errors.settingsInfo?.appname && watch("settingsInfo?.appname")?.length >= 3 && (
                                                                                    <div className="text-success small mt-1">
                                                                                        Application name is available
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div class="add-numbermain">
                                                                            <div class="tel-numbers">Organization Name</div>
                                                                            <div class="w-30">
                                                                                <MDBInput
                                                                                    {...register("settingsInfo.org_name", {
                                                                                        // required: "Organization Name is required",
                                                                                    })}
                                                                                />
                                                                                {errors.settingsInfo?.org_name && (
                                                                                    <div class="text-danger small mt-1">
                                                                                        {errors.settingsInfo.org_name.message}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div class="add-numbermain">
                                                                            <div class="tel-numbers">Organization Website</div>
                                                                            <div class="w-30">
                                                                                <MDBInput
                                                                                    type="url"
                                                                                    {...register("settingsInfo.org_website", {
                                                                                        // required: "Organization Website is required",
                                                                                    })}
                                                                                />
                                                                                {errors.settingsInfo?.org_website && (
                                                                                    <div className="text-danger small mt-1">
                                                                                        {errors.settingsInfo.org_website.message}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div class="add-numbermain align-items-center">
                                                                            <div class="tel-numbers">Description</div>
                                                                            <div class="w-30">
                                                                                <MDBTextArea
                                                                                    defaultValue={getValues("settingsInfo.description")}
                                                                                    onChange={(e) => {
                                                                                        setValue("settingsInfo.description", (e.target.value), {
                                                                                            shouldDirty: true,
                                                                                        });
                                                                                    }}

                                                                                />
                                                                                {errors.settingsInfo?.description && (
                                                                                    <div className="text-danger small mt-1">
                                                                                        {errors.settingsInfo.description.message}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <StreamsPermissions
                                                                            togglePermission={togglePermission}
                                                                            removePermission={removePermission}
                                                                            selectedPermissions={selectedPermissions}
                                                                            handleWebhookChange={handleWebhookChange}
                                                                            apiUrls={apiUrls}
                                                                            register={register}
                                                                            errors={errors}
                                                                            dirtyFields={dirtyFields}
                                                                            clearErrors = {clearErrors}
                                                                            setError = {setError}/>
                                                                         

                                                                    </section>

                                                                    <div className="routing-border"></div>

                                                                    <section ref={section2} id="section-2" className="create_apiApps" style={{ paddingBottom: "20rem" }}>
                                                                        <div class="general-settings" id="general">
                                                                            Client Credentials
                                                                        </div>
                                                                        <div class="add-numbermain">
                                                                            <div class="tel-numbers">Account ID</div>
                                                                            <div class="w-30 pe-6 position-relative custom-input-m-0">
                                                                                <MDBInput {...register("settingsInfo.account_id", {
                                                                                })} disabled />
                                                                                <div className="cursor-pointer custom-input-icon">
                                                                                    <MDBIcon far icon="copy" color="primary" size="1x" className="copyIcon"
                                                                                        onClick={() => copyToClipboard(appInfo.account_id)} />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div class="add-numbermain">
                                                                            <div class="tel-numbers">Client ID</div>
                                                                            <div class="w-30 pe-6 position-relative custom-input-m-0">
                                                                                <MDBInput  {...register("settingsInfo.client_id", {
                                                                                })} disabled />
                                                                                <div className="cursor-pointer custom-input-icon">
                                                                                    <MDBIcon far icon="copy" color="primary" size="1x" className="copyIcon"
                                                                                        onClick={() => copyToClipboard(appInfo.client_id)} />
                                                                                </div>

                                                                            </div>
                                                                        </div>

                                                                        <div class="add-numbermain">
                                                                            <div class="tel-numbers">Client Secret </div>
                                                                            <div class="w-30 pe-6 position-relative custom-input-m-0">
                                                                                <MDBInput {...register("settingsInfo.client_secret", {
                                                                                })}
                                                                                    disabled type={isFirstImage ? "text" : "password"} />

                                                                                <div className="cursor-pointer custom-input-icon end-0 d-flex align-items-center">
                                                                                    <MDBIcon far icon="copy" color="primary" size="1x" className="copyIcon"
                                                                                        onClick={() => copyToClipboard(appInfo.client_secret)} />
                                                                                    <MDBIcon far icon={isFirstImage ? 'eye-slash' : 'eye'} color="primary" className="password-toggle mx-2" size="1x"
                                                                                        onClick={toggleImage} />
                                                                                    <MDBIcon fas icon="sync" color="primary" size="1x" className=" regenerate-icon" onClick={() => setRegeneratePopup(!isRegeneratePopup)} />

                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div class="add-numbermain">
                                                                            <div class="tel-numbers">Base64 String</div>
                                                                            <div class="w-30 pe-6 position-relative custom-input-m-0">
                                                                                <MDBInput className="m-0" {...register("settingsInfo.base64_string", {
                                                                                })} disabled />
                                                                                <div className="cursor-pointer custom-input-icon">
                                                                                    <MDBIcon far icon="copy" color="primary" size="1x" className="copyIcon"
                                                                                        onClick={() => copyToClipboard(appInfo.base64_string)} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="add-numbermain">
                                                                            <div class="tel-numbers">Authorization URL</div>
                                                                            <div class="w-30 pe-6 position-relative custom-input-m-0">
                                                                                <MDBInput {...register("settingsInfo.redirect_url", {
                                                                                })} disabled />
                                                                                <div className="cursor-pointer custom-input-icon me-3 end-0 d-flex align-items-center" onClick={() =>
                                                                                    console.log('hello')}>

                                                                                    <MDBIcon far icon="copy" color="primary" size="1x" className="copyIcon me-2 "
                                                                                        onClick={() => copyToClipboard(appInfo.redirect_url)} />
                                                                                    <MDBIcon far icon="question-circle" color="primary" size="1x" className="Authorization-info" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </section>
                                                                </div>
                                                            </MDBCol>
                                                        </MDBRow>
                                                    </MDBTabsPane>
                                                </MDBTabsContent>
                                            </form>
                                        </div>
                                    </>
                                )}
                            </div>
                        </section>
                        {isDirty && (
                            <SaveChanges
                                onClose={onCloseChanges}
                                onSave={() => handleSubmit(onsaveChanges)()}
                            />
                        )}
                        {isRegeneratePopup && <RegenerateClientSecretPopup open={isRegeneratePopup} setOpen={setRegeneratePopup} Info={appInfo} />}
                        {istoggleAlertPopup && 
                        <StreamsAPIWebHookURLAlert 
                        open={istoggleAlertPopup} 
                        saveButtonChanges={saveButtonChanges} 
                        setOpen={SetIstoggleAlertPopup} 
                        setActionType={setActionType} 
                        cancelApiUrls={cancelApiUrls} 
                        onCloseChanges={onCloseChanges}
                        alertHeader={alertHeader}
                        changedWebhooks={changedWebhooks}
                         />}
                    </>
                }
            />

            <Tooltip anchorSelect=".Authorization-info" place="top" className="exampleTooltipLight">
                Use this URL to get the Access token <br /> followed by token end point URI.
            </Tooltip>

            <Tooltip anchorSelect=".copyIcon" place="top" className="exampleTooltipLight">
                Copy to clipboard
            </Tooltip>

            <Tooltip anchorSelect=".regenerate-icon" place="top" className="exampleTooltipLight">
                Regenerate client secret
            </Tooltip>

            <Tooltip anchorSelect=".password-toggle" place="top" className="exampleTooltipLight">
                {isFirstImage ? "Hide client secret" : "Show client secret"}
            </Tooltip>
            <Tooltip anchorSelect=".Authorization-infoData" place="top" className="exampleTooltipLight">
                Enter a valid WebHook URL to receive <br />incoming SMS messages to your application.
            </Tooltip>

            {showTooltip && (
                <MDBAlert
                    open
                    color="success"
                    autohide
                    className="alert-center"
                    position="bottom-right"
                    delay={2000}
                    onClose={() => setShowTooltip(false)}
                >
                    <MDBIcon far icon="check-circle" color="success" className="me-2" />

                    Copied to clipboard
                </MDBAlert>
            )}

        </React.Fragment>
    )
}


export default StreamsApiSettings
